import { fromJS } from 'immutable';

export default fromJS({
    facilities: [],
    facility: {}
});